import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../utils/helpers";
import { styles } from "./adminStyles";

const EpostaTab = ({ profile }) => {
  const [alarmEmails, setAlarmEmails] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [emailSettings, setEmailSettings] = useState({
    sender_email: "alarm@qenkur.com",
    email_subject: "QEN Kuyumculuk - Fiyat Alarmi",
    email_header: "QEN Ozbek Kuyumculuk",
    email_subheader: "Fiyat Alarmi Bildirimi"
  });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const loadAlarmEmails = async () => {
    try {
      const res = await axios.get(`${API}/alarm/emails?profile=${profile || 'default'}`);
      setAlarmEmails(res.data.emails || []);
    } catch (e) { console.error(e); }
  };

  const loadEmailSettings = async () => {
    try {
      const res = await axios.get(`${API}/alarm/settings?profile=${profile || 'default'}`);
      if (res.data.settings) setEmailSettings(res.data.settings);
    } catch (e) { console.error(e); }
  };

  useEffect(() => { loadAlarmEmails(); loadEmailSettings(); }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps

  const addEmail = async () => {
    if (!newEmail.trim()) return;
    try {
      await axios.post(`${API}/alarm/emails`, { email: newEmail.trim(), profile });
      setNewEmail(""); loadAlarmEmails();
      setSuccess("E-posta eklendi!"); setTimeout(() => setSuccess(""), 3000);
    } catch (err) { setError(err.response?.data?.detail || "E-posta eklenemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const toggleEmail = async (id) => {
    try { await axios.post(`${API}/alarm/emails/toggle`, { id }); loadAlarmEmails(); } catch (e) { console.error(e); }
  };

  const deleteEmail = async (id) => {
    if (!window.confirm("Bu e-postayi silmek istediginize emin misiniz?")) return;
    try {
      await axios.post(`${API}/alarm/emails/delete`, { id });
      loadAlarmEmails();
      setSuccess("E-posta silindi!"); setTimeout(() => setSuccess(""), 3000);
    } catch (e) { console.error(e); }
  };

  const saveEmailSettings = async () => {
    try {
      await axios.post(`${API}/alarm/settings`, { ...emailSettings, profile });
      setSuccess("E-posta ayarlari kaydedildi!"); setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Ayarlar kaydedilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const sendTestEmail = async (email) => {
    try {
      await axios.post(`${API}/alarm/test-email`, { email, profile });
      setSuccess("Test e-postasi gonderildi!"); setTimeout(() => setSuccess(""), 3000);
    } catch (err) { setError(err.response?.data?.detail || "Test gonderilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  return (
    <div style={{display: 'flex', justifyContent: 'center', padding: '30px 20px'}}>
      <div style={styles.panel}>
        <h1 style={styles.title}>E-posta Bildirimleri</h1>
        {success && <p style={styles.success}>{success}</p>}
        {error && <p style={styles.error}>{error}</p>}

        <div style={{...styles.section, marginBottom: '20px'}}>
          <h3 style={{ color: '#09301E', marginBottom: '10px' }}>E-posta Ekle</h3>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input type="email" placeholder="ornek@email.com" value={newEmail}
              onChange={e => setNewEmail(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') addEmail(); }}
              style={{...styles.input, flex: 1, marginBottom: 0}} data-testid="new-email-input" />
            <button onClick={addEmail} style={{...styles.button, width: 'auto', padding: '15px 24px'}} data-testid="add-email-btn">
              Ekle
            </button>
          </div>
        </div>

        <div style={styles.section}>
          <h3 style={{ color: '#09301E', marginBottom: '12px' }}>Kayitli E-postalar</h3>
          {alarmEmails.length === 0 ? (
            <p style={{ color: '#888', textAlign: 'center', padding: '20px' }}>Henuz e-posta eklenmedi</p>
          ) : (
            alarmEmails.map(em => (
              <div key={em.id} data-testid={`email-item-${em.id}`} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '12px', borderBottom: '1px solid #ddd', gap: '8px'
              }}>
                <div style={{
                  flex: 1, fontSize: '14px', fontWeight: '500',
                  color: em.active ? '#333' : '#aaa',
                  textDecoration: em.active ? 'none' : 'line-through'
                }}>
                  {em.email}
                </div>
                <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                  <button onClick={() => toggleEmail(em.id)} data-testid={`toggle-email-${em.id}`}
                    style={{
                      padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold',
                      background: em.active ? '#22c55e' : '#888', color: '#fff'
                    }}>
                    {em.active ? 'Aktif' : 'Pasif'}
                  </button>
                  <button onClick={() => deleteEmail(em.id)} data-testid={`delete-email-${em.id}`}
                    style={{ padding: '6px 12px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold', background: '#e74c3c', color: '#fff' }}>
                    Sil
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <p style={{ color: '#888', fontSize: '12px', textAlign: 'center', marginTop: '15px' }}>
          Aktif e-postalara alarm tetiklendiginde bildirim gonderilir.
        </p>

        <div style={{...styles.section, marginTop: '20px'}}>
          <h3 style={{ color: '#09301E', marginBottom: '12px' }}>E-posta Ayarlari</h3>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '13px', fontWeight: '600', color: '#555' }}>Gonderen E-posta:</label>
            <input type="text" value={emailSettings.sender_email}
              onChange={e => setEmailSettings({...emailSettings, sender_email: e.target.value})}
              style={{...styles.input, fontSize: '14px', padding: '10px'}} data-testid="sender-email-input"
              placeholder="alarm@qenkur.com" />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '13px', fontWeight: '600', color: '#555' }}>E-posta Konusu:</label>
            <input type="text" value={emailSettings.email_subject}
              onChange={e => setEmailSettings({...emailSettings, email_subject: e.target.value})}
              style={{...styles.input, fontSize: '14px', padding: '10px'}} data-testid="email-subject-input"
              placeholder="QEN Kuyumculuk - Fiyat Alarmi" />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '13px', fontWeight: '600', color: '#555' }}>E-posta Basligi:</label>
            <input type="text" value={emailSettings.email_header}
              onChange={e => setEmailSettings({...emailSettings, email_header: e.target.value})}
              style={{...styles.input, fontSize: '14px', padding: '10px'}} data-testid="email-header-input"
              placeholder="QEN Ozbek Kuyumculuk" />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '13px', fontWeight: '600', color: '#555' }}>E-posta Alt Basligi:</label>
            <input type="text" value={emailSettings.email_subheader}
              onChange={e => setEmailSettings({...emailSettings, email_subheader: e.target.value})}
              style={{...styles.input, fontSize: '14px', padding: '10px'}} data-testid="email-subheader-input"
              placeholder="Fiyat Alarmi Bildirimi" />
          </div>
          <button onClick={saveEmailSettings} style={{...styles.saveButton, marginTop: '10px'}} data-testid="save-email-settings-btn">
            Ayarlari Kaydet
          </button>
        </div>

        <div style={{...styles.section, marginTop: '10px'}}>
          <h3 style={{ color: '#09301E', marginBottom: '8px' }}>Test E-postasi Gonder</h3>
          <p style={{ color: '#888', fontSize: '12px', marginBottom: '10px' }}>Kayitli e-postalardan birine test gonderin:</p>
          {alarmEmails.filter(e => e.active).map(em => (
            <button key={em.id} onClick={() => sendTestEmail(em.email)} data-testid={`test-email-${em.id}`}
              style={{ display: 'block', width: '100%', padding: '10px', marginBottom: '6px', background: '#334155', color: '#DA9F54', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>
              Test Gonder: {em.email}
            </button>
          ))}
        </div>

        <button onClick={() => window.location.href = profile === "default" ? "/" : `/${profile}`} style={{...styles.backButton, marginTop: '15px'}}>Fiyat Sayfasina Don</button>
      </div>
    </div>
  );
};

export default EpostaTab;
